import React, { useCallback } from 'react'
import { Label, NumericInput, Pane, Popup, PropertyGrid, Selector, Text } from '@leverege/ui-elements'
import I18n from '@leverege/i18n'

import { ScenarioActions } from '../../actions'

import S from './BehaviorEditor.css'

const { t } = I18n.ns( 'imagine.ScenarioEditor.BehaviorEditor' )

const defaults = {
  pass : {
    type : 'pass',
    sendFullState : true
  },
  aggregateCount : {
    type : 'aggregateCount',
    aggregate : 10
  },
  aggregateTime : {
    type : 'aggregateTime',
    aggregate : 10000
  },
}

export default function BehaviorEditor( props ) {
  const { scenarioData : { scenario }, dispatch } = props

  const behavior = scenario?.scenarioData?.behavior
  const type = behavior?.type
  const aggregate = behavior?.aggregate

  const onChangeType = useCallback(
    ( { value } ) => {
      if ( value !== type ) {
        dispatch( ScenarioActions.setBehavior( defaults[value] ) )
      }
    },
    [ type ]
  )

  const onChangeAggregate = useCallback(
    ( { value } ) => {
      const nBehavior = { ...behavior, aggregate : value }
      dispatch( ScenarioActions.setBehavior( nBehavior ) )
    },
    [ behavior ]
  )
  return (
    <PropertyGrid vertical>
      <PropertyGrid.Item label={(
        <Pane layout="flex:rowM">
          <Label>Type</Label>
          <Popup title="Help" icon="fa fa-question-circle fa-fw">
            <PropertyGrid labelVariant="subtitle" vertical className={S.hints}>
              <PropertyGrid.Item label={t( 'passThroughName' )}>
                <Text variant="bodySmall">
                  {t( 'passThroughDescription' )}
                </Text>
              </PropertyGrid.Item>
              <PropertyGrid.Item label={t( 'aggByTimeName' )}>
                <Text variant="bodySmall">
                  {t( 'aggByTimeDescription' )}
                </Text>
              </PropertyGrid.Item>
              <PropertyGrid.Item label={t( 'aggByCountName' )}>
                <Text variant="bodySmall">
                  {t( 'aggByCountDescription' )}
                </Text>
              </PropertyGrid.Item>
            </PropertyGrid>
          </Popup>
        </Pane>
      )}>
        <Selector
          values={[
            { value : 'pass', name : t( 'passThroughName' ) },
            { value : 'aggregateTime', name : t( 'aggByTimeName' ) },
            { value : 'aggregateCount', name : t( 'aggByCountName' ) },
          ]}
          value={type}
          onChange={onChangeType}/>
      </PropertyGrid.Item>
      {type !== 'pass' ? (
        <PropertyGrid.Item label={type === 'aggregateCount' ? 'Messages to Aggregate' : 'Time to Aggregate (ms)'}>
          <NumericInput value={aggregate} onChange={onChangeAggregate} />
        </PropertyGrid.Item>
      ) : null}
    </PropertyGrid>
  )
}
